import React, { useState, useEffect } from 'react';
import { login } from '../api/api';

function LoginModal({ setToken, closeModal, openSignupModal, openResetPasswordModal }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    // Only show session expired message if there was a previous session
    // (indicated by having a refresh token but no access token)
    const accessToken = localStorage.getItem('access_token');
    const refreshToken = localStorage.getItem('refresh_token');
    
    if (!accessToken && refreshToken) {
      setError('Your session has expired. Please log in again.');
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await login(username, password);
      setToken(response.access_token);
      setError('');
      closeModal();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-[var(--bg-secondary)] p-6 rounded-xl shadow-lg max-w-md w-full">
        <h3 className="text-lg font-semibold mb-4 text-[var(--text-primary)]">Login</h3>
        {error && (
          <div className="bg-danger-light border text-danger px-4 py-2 rounded-lg mb-4">
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <input
              type="text"
              className="w-full p-2 border border-gray-300 dark:border-slate-600 rounded-lg text-[var(--text-primary)] bg-[var(--bg-secondary)] focus:ring-2 focus:ring-[var(--secondary)] focus:border-[var(--primary)] transition-all duration-200"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>
          <div className="mb-4">
            <input
              type="password"
              className="w-full p-2 border border-gray-300 dark:border-slate-600 rounded-lg text-[var(--text-primary)] bg-[var(--bg-secondary)] focus:ring-2 focus:ring-[var(--secondary)] focus:border-[var(--primary)] transition-all duration-200"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="flex justify-between text-sm mb-4">
            <button
              type="button"
              onClick={openSignupModal}
              className="text-[var(--text-secondary)] hover:text-[var(--text-primary)] hover:underline transition-colors duration-200"
            >
              Sign Up
            </button>
            <button
              type="button"
              onClick={openResetPasswordModal}
              className="text-[var(--text-secondary)] hover:text-[var(--text-primary)] hover:underline transition-colors duration-200"
            >
              Forgot Password?
            </button>
          </div>
          <div className="flex gap-2">
            <button
              type="submit"
              className="px-4 py-2 bg-[var(--primary)] text-white rounded-lg text-sm hover:bg-[var(--text-secondary)] transition-colors duration-200"
            >
              Login
            </button>
            <button
              type="button"
              className="px-4 py-2 bg-[var(--secondary)] bg-opacity-20 text-[var(--text-primary)] rounded-lg text-sm hover:bg-[var(--secondary)] hover:text-white transition-all duration-200"
              onClick={closeModal}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginModal;